export function getCurrentISODateString(): string {
  return new Date().toISOString().substr(0, 10)
}

/**
 * Create a string representing year and month from Date object
 */
export function getLocalMonthString(date: Date): string {
  const options = {
    year: 'numeric',
    month: 'long'
  }
  return date.toLocaleDateString('et', options)
}

class MonthInfo {
  constructor(readonly name: string, readonly genitive: string) {}
}

export class MonthMapper {
  private static readonly MONTHS = [
    new MonthInfo('jaanuar', 'jaanuari'),
    new MonthInfo('veebruar', 'veebruari'),
    new MonthInfo('märts', 'märtsi'),
    new MonthInfo('aprill', 'aprilli'),
    new MonthInfo('mai', 'mai'),
    new MonthInfo('juuni', 'juuni'),
    new MonthInfo('juuli', 'juuli'),
    new MonthInfo('august', 'augusti'),
    new MonthInfo('september', 'septembri'),
    new MonthInfo('oktoober', 'oktoobri'),
    new MonthInfo('november', 'novembri'),
    new MonthInfo('detsember', 'detsembri')
  ]

  static getNameByIndex(index: number): string {
    return MonthMapper.MONTHS[index - 1].name
  }

  static getGenitiveByIndex(index: number): string {
    return MonthMapper.MONTHS[index - 1].genitive
  }

  /**
   * Items for MonthInput component
   */
  static getSelectItems(): Array<SelectItem> {
    return MonthMapper.MONTHS.reduce((accumulator, monthInfo, index) => {
      accumulator.push({ name: monthInfo.name, key: index + 1 })
      return accumulator
    }, [])
  }

  static getMonthNames(): Array<string> {
    return MonthMapper.MONTHS.map(monthInfo => monthInfo.name)
  }

  static getCurrentMonthIndex(): number {
    // In JS Date object, month indexes start from 0, in our system they start with one.
    return Number(new Date().getMonth() + 1)
  }
}

interface SelectItem {
  name: string
  key: number
}

// There might not be separator between hours and minutes, because it is automatically created by v-text-field mask
export const timeRegex = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):?[0-5][0-9]$/
